import React from 'react';
import { IItemRestaurant } from 'types';
import moment from 'moment';
import Text from 'components/Text/Text';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: IItemRestaurant;
	index: number;
}

export const Item: React.FC<IProps> = ({ data, index }) => {
	const nameRowClasses = classNames(style.row, style.name);
	const customerRowClasses = classNames(style.row, style.customer);
	const cityRowClasses = classNames(style.row, style.city);
	const countryRowClasses = classNames(style.row, style.country);
	const deletingDateClasses = classNames(style.row, style.deletingDate);
	const userClasses = classNames(style.row, style.user);

	return (
		<div className={style.container} data-test={`Item-${index}`}>
			<div className={nameRowClasses}>
				<Text className={style.customerName} translationKey={data.name} withTooltip={true} />
				<ChunkOfTextWithCopying text={data.id} className={style.copyId} />
			</div>
			<Text className={customerRowClasses} translationKey={data.customer.name} withTooltip={true} />
			<Text className={cityRowClasses} translationKey={data.city.name} withTooltip={true} />
			<Text className={countryRowClasses} translationKey={data.country.name} withTooltip={true} />
			<Text
				className={deletingDateClasses}
				translationKey={data.deletedDate ? moment(data.deletedDate).format('MM/DD/YYYY h:mm:ss A') : '-'}
				withTooltip={true}
			/>
			<Text className={userClasses} translationKey={data.deletedBy || '-'} withTooltip={true} />
		</div>
	);
};
